import { render, staticRenderFns } from "./DocPublicacoesAcoes.vue?vue&type=template&id=3b428ef2&scoped=true&lang=pug&"
import script from "./DocPublicacoesAcoes.vue?vue&type=script&lang=js&"
export * from "./DocPublicacoesAcoes.vue?vue&type=script&lang=js&"
import style0 from "./DocPublicacoesAcoes.vue?vue&type=style&index=0&id=3b428ef2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b428ef2",
  null
  
)

export default component.exports